import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams, useRouter } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useQueriesWithGlobal } from '@data-access';
import { fieldsQueries, MAP_TYPES } from '@fields/data-access';

export function useCreateMapPageShared() {
  const { t } = useTranslation();
  const { fieldId } = useParams({
    from: '/_app/fields_/$fieldId_/maps/$editableMapType/create',
  });
  const { navigate } = useRouter();

  const queries = useQueriesWithGlobal(fieldsQueries);
  const { data } = useSuspenseQuery(queries.detail(Number(fieldId)));

  const navToField = (mapType: MAP_TYPES) =>
    navigate({
      to: '/fields/$fieldId/maps/$mapType',
      params: {
        fieldId,
        mapType: mapType,
      },
    });

  return {
    field: data,
    navToField,
    t,
    fieldId,
  };
}

export default useCreateMapPageShared;
